export default "__VITE_ASSET__adff1fb8__"